import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DeleteIcon } from 'ui-component/custom-icons/icons';
import Pagination from 'ui-component/Pagination';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import { FaPlus, FaSearch } from 'react-icons/fa';
import { Skeleton } from '@mui/material';
import toast from 'react-hot-toast';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import usePageTitle from 'hooks/usePageTitle';
import BankModal from './modals/BankModal';
import useIsMobile from 'utils/isMobileUtils';
import NoRecordFoundIcon from 'assets/images/icons/no-records-found.svg';

// ✅ Clear
const SettingsBanks = () => {
    const [setPageTitle] = usePageTitle('Settings');
    useEffect(() => {
        return () => {
            setPageTitle(null);
        };
    }, []);
    const history = useNavigate();
    const [showDelete, setShowDelete] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [pagination, setpagination] = useState([]);

    const [searchField, setSearchField] = useState();
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [activeFilters, setActiveFilters] = useState({});
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [banks, setBanks] = useState([]);
    const [selectedBank, setSelectedBank] = useState({
        id: '',
        currency: '',
        currencyId: '',
        bankName: '',
        beneficiary: '',
        iban: '',
        swiftCode: '',
        branch: '',
    });


    const getRecord = () => {
        setIsLoading(true);
        api
            .getSettingsBanks()
            .then((res) => {
                setIsLoading(false);
                if (res.status) {
                    setBanks(res?.data?.data);
                    setpagination(res?.data);
                } else {
                    setBanks([]);
                }
                isFirstLoad && setIsFirstLoad(false);
            })
            .catch((error) => {
                setIsLoading(false);
                setBanks([]);
                console.error('Failed to fetch returns list:', error);
            });
    };
    const handleSearch = (e) => {
        let text = e.target.value;
        setSearchField(text);

        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        let timeout = setTimeout(() => {
            setIsLoading(true);
            if (text.length > 2) {
                api.filterBanks(activeFilters, text).then((res) => {
                    setIsLoading(false);
                    setBanks(res.data.data);
                    setpagination(res.data);
                });
            } else if (text.length > 0 && text.length <= 2) {
                setIsLoading(false);
            } else {
                api.filterBanks(activeFilters, null).then((res) => {
                    setIsLoading(false);
                    setBanks(res.data.data);
                    setpagination(res.data);
                });
            }
        }, 1000);

        setSearchTimeout(timeout);
    };

    useEffect(() => {
        !isFirstLoad && handleFilter();
    }, [activeFilters]);

    const handleFilter = (activeF = null, searchF = null) => {
        setIsLoading(true);
        api.filterBanks(activeFilters, searchField?.length > 2 ? searchField : null).then((res) => {
            setIsLoading(false);
            setBanks(res.data.data);
            setpagination(res.data);
        });
    };



    const handleClose = () => { 
        setShowModal(false)
        setShowDelete(null);
    }
    const handleReloadList = () => { 
        setShowModal(false)
        setSelectedBank({
            ...selectedBank,
            id: '',
            currency: '',
            currencyId: '',
            bankName: '',
            beneficiary: '',
            iban: '',
            swiftCode: '',
            branch: '',
        })
        getRecord();
    }

    const handleData = (data) => {
        setBanks(data.data);
        setpagination(data);
    };

    useEffect(() => {
        getRecord();
    }, []);
    
    const handleCreateBank = () => {

        setShowModal(true);
        setSelectedBank({
            ...selectedBank,
            id: '',
            currency: '',
            currencyId: '',
            bankName: '',
            beneficiary: '',
            iban: '',
            swiftCode: '',
            branch: '',
        })
    }

    const handleDelete = (id) => {
        toast.promise(
            api.settingsDeleteBank(showDelete?.id).then((res) => {
                if (res.status) {
                    handleClose();
                    getRecord()
                }
                return res?.status ? res : abc;
            }),
            {
                loading: 'Deleting bank details...',
                success: (data) => `${data.message}`,
                error: <b>Failed to delete bank details</b>
            }
        );
    };

    const deleteBank = (data) => {
        setShowDelete(data);
    };

    const handleViewData = (data) => {

        setShowModal(true);
        setSelectedBank({
            ...selectedBank,
            id: data.id,
            currency: data?.currency,
            currencyId: data?.currency_id,
            bankName: data?.bank_name,
            beneficiary: data?.beneficiary,
            iban: data?.iban,
            swiftCode: data?.swift_code,
            branch: data?.branch,
        })
    }


    useEffect(() => {
        if (showModal) {
          window.addEventListener('keydown', handleKeyDown);
        } else {
          window.removeEventListener('keydown', handleKeyDown);
        }
    
        // Cleanup event listener on component unmount
        return () => {
          window.removeEventListener('keydown', handleKeyDown);
        };
    }, [showModal]);

    const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
          setShowModal(false);
        }
    };

    const isMobile = useIsMobile();
    

    return (
		<>
			<div className="row">
				<div className={`col-lg-8 col-md-8 col-12  ${isMobile ? '' : 'offset-lg-2 offset-md-2'}`}>
					<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
						<div className="header-bubble" />
						<div className="d-flex flex-column " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
							<div
								style={{
									position: 'relative',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									marginBottom: 8,
									minHeight: 38 // ensures enough height for the button
								}}
							>
								<button
									type="button"
									aria-label="Back"
									onClick={() => history(-1)}
									className="circle-back-btn"
									style={{
										position: 'absolute',
										left: 20,
										top: '50%',
										transform: 'translateY(-50%)'
									}}
								>
									{/* Replace with your fi arrow icon, example below */}
									<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
										<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
									</svg>
								</button>
								<h5
									style={{
										textAlign: 'center',
										flex: 1,
										margin: 0,
										display: 'flex',
										gap: 10,
										justifyContent: 'center',
										alignItems: 'center'
									}}
								>
									Bank Details
								</h5>
							</div>
							<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
								<PermissionAllowed permissions={['List Purchase Order']}>
									<button
										className="bulk-action btn-primary btn-outlined-main-primary  white-var"
										onClick={() => {
											handleCreateBank();
										}}
									>
										<span className="menuIcon">
											<FaPlus style={{ fontSize: '13px', marginTop: '-3px' }} />
										</span>
										<span>New</span>
									</button>
								</PermissionAllowed>
							</div>
						</div>
					</div>
					<div className="section-head-new hide-on-mobile" style={{ margin: '10px 20px 0px 1px' }}>
						<div className="actions">
							<PermissionAllowed permissions={['List Purchase Order']}>
								<button
									className="bulk-action btn-primary btn-outlined-main-primary  white-var"
									onClick={() => {
										handleCreateBank();
									}}
								>
									<span className="menuIcon">
										<FaPlus style={{ fontSize: '13px', marginTop: '-3px' }} />
									</span>
									<span>New</span>
								</button>
							</PermissionAllowed>
						</div>
					</div>
					<div
						style={{
							justifyContent: 'space-between',
							alignItems: 'center',
							gap: 10,
							paddingLeft: '20px',
							paddingRight: 20,
							paddingBottom: 5
						}}
						className="show-on-mobile"
					>
						<form className="form-inline navbar-search" style={{ flex: 1 }}>
							<div style={{ position: 'relative', width: '100%' }}>
								<input
									type="text"
									className="form-control bg-white border"
									placeholder="Search"
									aria-label="Search"
									aria-describedby="basic-addon2"
									onChange={handleSearch}
									style={{ width: '100%' }}
								/>
								<span
									className="searchIcon"
									style={{
										position: 'absolute',
										right: 10,
										top: '50%',
										transform: 'translateY(-50%)',
										color: '#888',
										pointerEvents: 'none'
									}}
								>
									<FaSearch />
								</span>
							</div>
						</form>
					</div>
					<div className="card shadow-sm bg-white mb-4">
						<div className=" align-items-center justify-content-between TableSerachBar">
							<div>
								<div className="actions">
									<div style={{ margin: '0 5px' }}>
										<h5>Bank Details</h5>
									</div>
								</div>
							</div>
							<form className="form-inline navbar-search" onSubmit={(e) => e.preventDefault()}>
								<div className="input-group">
									<input
										type="text"
										className="form-control bg-white border"
										placeholder="Search"
										aria-label="Search"
										aria-describedby="basic-addon2"
										onChange={handleSearch}
										style={{ width: '100%' }}
									/>
									<span className="searchIcon">
										<FaSearch />
									</span>
								</div>
							</form>
						</div>
						{!isMobile ? (
							<div className="table-responsive-xl tableData customersList p-2 mt-16">
								<table className="table pm-table">
									<thead>
										<tr className="sticky-header">
											<th scope="col font500">Bank</th>
											<th scope="col font500">Currency</th>
											<th scope="col font500">Beneficiary </th>
											<th scope="col font500">IBAN </th>
											<th scope="col font500">Swift </th>
											<th scope="col font500">Branch </th>
										</tr>
									</thead>
									<tbody>
										{isLoading ? (
											[...Array(10)].map((e, i) => (
												<tr>
													{[...Array(6)].map((e, i) => (
														<td>
															<Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
														</td>
													))}
												</tr>
											))
										) : (
											<>
												{banks?.map((row, index) => {
													return (
														<tr key={index} className="hover-row">
															<td
																className="align-middle cursor-pointer"
																onClick={() => {
																	handleViewData(row);
																}}
															>
																{row?.bank_name}
															</td>
															<td
																className="align-middle cursor-pointer"
																onClick={() => {
																	handleViewData(row);
																}}
															>
																{row?.currency}
															</td>
															<td
																className="align-middle cursor-pointer"
																onClick={() => {
																	handleViewData(row);
																}}
															>
																{row?.beneficiary}
															</td>
															<td
																className="align-middle cursor-pointer"
																onClick={() => {
																	handleViewData(row);
																}}
															>
																{row?.iban}
															</td>
															<td
																className="align-middle cursor-pointer"
																onClick={() => {
																	handleViewData(row);
																}}
															>
																{row?.swift_code}
															</td>
															<td
																className="align-middle cursor-pointer"
																onClick={() => {
																	handleViewData(row);
																}}
															>
																{row?.branch}
															</td>

															<td className="hover-button-container">
																<div>
																	<div className="hover-button">
																		<PermissionAllowed permissions={['Delete Operations']}>
																			<div
																				className="btn btn-danger btn-outlined-danger white-var btn-sm cursor-pointer"
																				style={{ marginLeft: '8px' }}
																				onClick={() => {
																					deleteBank(row);
																				}}
																			>
																				<div style={{ margin: 'auto 3px' }}>
																					<DeleteIcon height="14px" width="14px" />
																				</div>
																			</div>
																		</PermissionAllowed>
																	</div>
																</div>
															</td>
														</tr>
													);
												})}
												{banks?.length < 1 && (
													<tr className="no-hover">
														<td className="whitebg" colSpan={6} style={{ textAlign: 'center' }}>
															<div className="not-found-container">
																<div className="not-found-icon">
																	<img src={NoRecordFoundIcon} style={{ height: '200px', width: '200px' }} />
																</div>
																<h6 className="not-found-text">No Data Available</h6>
																<div
																	className="cursor-pointer btn btn-primary btn-outlined-main"
																	onClick={() => {
																		handleCreateBank();
																	}}
																>
																	Create Bank Details
																</div>
															</div>
														</td>
													</tr>
												)}
											</>
										)}
									</tbody>
								</table>
							</div>
						) : (
							<div
								className="mobile-product-list"
								style={{
									height: 'calc(100dvh - 300px)',
									overflowY: 'auto',
									display: 'flex',
									flexDirection: 'column'
								}}
							>
								{isLoading ? (
									[...Array(10)].map((_, i) => (
										<div
											key={i}
											className="mobile-product-card skeleton"
											style={{
												borderRadius: 12,
												background: '#f5f5f5',
												padding: 16,
												minHeight: 60,
												marginBottom: 8
											}}
										>
											<Skeleton variant="rounded" width={'100%'} height={30} />
										</div>
									))
								) : banks?.length > 0 ? (
									banks?.map((row, index) => (
										<div
											key={index}
											className="mobile-product-card"
											style={{
												borderBottom: '1px solid #eee',
												padding: '10px 20px',
												background: index % 2 === 0 ? '#fff' : '#f9f9f9',
												display: 'flex',
												alignItems: 'center',
												width: '100%'
											}}
											onClick={() => {
												handleViewData(row);
											}}
										>
											<div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
												<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
													<div style={{ fontWeight: 600, color: '#316aff', fontSize: 15 }}> {row?.bank_name}</div>
													<div style={{ fontSize: 12, color: '#888' }}>{row.currency}</div>
												</div>
												<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
													<div className="textGray">Beneficiary</div>
													<div style={{ fontWeight: 500 }}>{row.beneficiary}</div>
												</div>
												<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
													<div className="textGray">IBAN</div>
													<div style={{ fontWeight: 500 }}>{row.iban}</div>
												</div>
												<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
													<div className="textGray">Swift Code</div>
													<div style={{ fontWeight: 500 }}>{row.swift_code}</div>
												</div>
												<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
													<div className="textGray">Branch</div>
													<div style={{ fontWeight: 500 }}>{row.branch}</div>
												</div>
												<div style={{ display: 'flex', justifyContent: 'end' }}>
													<PermissionAllowed permissions={['Delete Operations']}>
														<div
															className="btn btn-danger btn-outlined-danger white-var btn-sm cursor-pointer"
															style={{ marginLeft: '8px' }}
															onClick={() => {
																deleteBank(row);
															}}
														>
															<div style={{ margin: 'auto 3px' }}>
																<DeleteIcon height="14px" width="14px" />
															</div>
														</div>
													</PermissionAllowed>
												</div>
											</div>
										</div>
									))
								) : (
									<div className="no-data-container">
										<img src={NoRecordFoundIcon} style={{ height: '100px', width: '100px' }} />
										<h6 className="no-data-text">No Data Available</h6>
										<div
											className="cursor-pointer btn btn-primary btn-outlined-main"
											onClick={() => {
												handleCreateBank();
											}}
										>
											Create Bank Details
										</div>
									</div>
								)}
							</div>
						)}
						<Pagination pagination={pagination} data={handleData} onLoading={(e) => setIsLoading(e)} />
						<div style={{ marginBottom: '8px' }}></div>
					</div>
				</div>
			</div>

			{showDelete && (
				<DeleteConfirmation
					show={showDelete}
					handleClose={handleClose}
					handleDelete={handleDelete}
					title="Confirm"
					message={`Are you sure you want to delete selected record?`}
					customDeleteButtonText={'Yes, Delete this bank details'}
				/>
			)}

			{showModal && (
				<BankModal openPopup={showModal} details={selectedBank} handleClose={handleClose} handleReloadList={handleReloadList} />
			)}
		</>
	);
};

export default SettingsBanks;
